import { render, staticRenderFns } from "./CriticalRiskPresenter.vue?vue&type=template&id=39be181f&scoped=true"
import script from "./CriticalRiskPresenter.vue?vue&type=script&lang=js"
export * from "./CriticalRiskPresenter.vue?vue&type=script&lang=js"
import style0 from "./CriticalRiskPresenter.vue?vue&type=style&index=0&id=39be181f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39be181f",
  null
  
)

export default component.exports